import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModulesApisService } from '../services/modules-apis.service';


@Component({
  selector: 'app-joinvideocall',
  templateUrl: './joinvideocall.page.html',
  styleUrls: ['./joinvideocall.page.scss'],
})
export class JoinvideocallPage implements OnInit {

  @Input() doctorProfile;

  constructor(public modalCtrl: ModalController,public authService: ModulesApisService) { }

  ngOnInit() {
    console.log(this.doctorProfile);
  }

  joinVideoCall(callstatus)
  {
    //alert(callstatus);    
    this.modalCtrl.dismiss(callstatus);
  }

}
